export default {
  maintenance: false,
  authenticated: false,
  refreshing: false,
  twoFactorVerification: false,
};



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/state.js